import React, { useState, useEffect } from 'react';
import useAxiosPrivate from "./hooks/useAxiosPrivate"
import CompanyPrice from './CompanyPrice'

export const getClassName = (index, data) => {
    if (index % 2 === 0) {
        if (data > 0) {
            return "PeerTabledataCenter SubHeader OddDiv Green"
        } else if (data < 0) {
            return "PeerTabledataCenter SubHeader OddDiv Red"
        } else {
            return "PeerTabledataCenter SubHeader OddDiv Black"
        }
    } else {
        if (data > 0) {
            return "PeerTabledataCenter SubHeader Green"
        } else if (data < 0) {
            return "PeerTabledataCenter SubHeader Red"
        } else {
            return "PeerTabledataCenter SubHeader Black"
        }
    }
}

function CompanyInvestorActivity(props) {
    window.scrollTo(0, 0)
    const [pageData, setpageData] = useState({ pageLoaded: false });
    const axiosPrivate = useAxiosPrivate();

    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/gurus/" + props.companySymbol + "/activity?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponse = await axiosPrivate.get(url);
        if (cdresponse.data.status === "Not Found") {
            setpageData({ dataNotFound: true, pageLoaded: true })
            return
        }
        document.title = cdresponse.data.company_name + " : Superinvestor ownership";
        setpageData(cdresponse.data)

    }

    const getUrl = (url) => {
        return "/Investor/" + url
    }

    useEffect(() => {
        companyDetails()
    }, [])


    return (
        <div id="CompanyInvestorActivity">
            <section className="optionsFinData">
                <div className="leftAlign growthCompanyName" style={{ paddingLeft: "0px", fontWeight: "600" }}>
                    <CompanyPrice companySymbol={props.companySymbol} name={pageData.company_name} />
                </div>
            </section>
            <div style={{ backgroundColor: "white", borderRadius: "10px", width: "fit-content", padding: "10px 0px" }}>
                <table className="PeersTable finData" style={{ backgroundColor: "white", width: "800px" }}>
                    <tbody>
                        <tr>
                            <td className="PeerColumnHeading PeerTabledataCenter">History</td>
                            <td className="PeerColumnHeading PeerTabledataCenter">Name</td>
                            <td className="PeerColumnHeading PeerTabledataCenter">% of ownership</td>
                            <td className="PeerColumnHeading PeerTabledataCenter">Activity</td>
                        </tr>
                    </tbody>
                    <tbody>
                        {pageData.activities?.map(dataKey => (
                            <>
                                <tr>
                                    <td className="PeerTabledataLeft SubHeader" colspan="6" style={{ textAlign: "left", paddingLeft: "50px", fontSize: "12px", fontWeight: "500" }}>{dataKey.quarter}</td>
                                </tr>
                                {dataKey.activity?.map((dataItem, index) => (
                                    <tr>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"}>&nbsp;</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"}><a href={getUrl(dataItem.shareholder_id)} target="_blank" style={{ textDecoration: "None" }}>{dataItem.shareholder_name}</a></td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"}>{dataItem.pct_of_ownership} %</td>
                                        <td className={getClassName(index, dataItem.pct_change)}>{dataItem.activity.charAt(0).toUpperCase() + dataItem.activity.slice(1)} </td>
                                    </tr>
                                ))
                                }

                            </>
                        ))}
                        {(pageData.dataNotFound === true || pageData.activities?.length === 0 || pageData.activities === undefined) && pageData.pageLoaded &&
                            <tr>
                                <td colspan={pageData.columns?.length + 2}>Data not found</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default CompanyInvestorActivity;